import { Action } from 'helpers/action-helpers';

export const CLEAR_LIST = 'ClearListAction';
export class ClearListAction extends Action {
  constructor() { 
    super(CLEAR_LIST);
  }
}


// WEBPACK FOOTER //
// ./src/components/clear-list/actions.ts